import { motion } from "framer-motion";

export const About = () => (
  <section id="about" className="section about">
    <motion.div className="about-mark" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 1.2 }}>KGS</motion.div>
    <motion.div className="about-copy" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}>
      <p className="eyebrow">THE PEOPLE BEHIND THE POWER</p>
      <h2 className="sec-title">Local knowledge.<br /><em>Serious service.</em></h2>
      <p>M/S KRISHNA GENERATOR SERVICE is built on a simple promise: deliver dependable power and stand behind it. Led by <strong>Mr. Ramdev Pandit</strong>, we serve businesses and project sites across Assam with practical, honest support.</p>
      <div className="people">
        <div><span>OWNER</span><strong>Mr. Ramdev Pandit</strong></div>
        <div><span>ACCOUNTANT</span><strong>Mr. Dhanjit Kalita</strong></div>
      </div>
    </motion.div>
  </section>
);
